<style>
#commonComponent {
  max-width: 200px;
}
#commonComponent .v-select__selection {
  font-size: 12px;
}
.attach-select {
  display: none;
}
#commonComponent .ribbon-button.ribbon__row {
  min-height: 37px !important;
}
</style>

<template>
  <div
    class="container__group--rows"
    id="commonComponent"
  >
    <div
      class="ribbon-button ribbon__row"
      @click="show('printModal')"
    >
      <span class="icon">
        <v-icon small>print</v-icon>
      </span>
      <button class="caption">Drukuj</button>
    </div>
    <div
      class="ribbon-button ribbon__row"
      id="mapSelect"
    >
      <v-select
        :items="baselayers"
        item-text="display_name"
        :return-object="true"
        v-model="currentBasemap"
        no-data-text="Brak warstw"
        height="16"
        placeholder="Warstwy podkładowe"
        id="ribbon-row__select--base"
        class="attach-nonselect"
      ></v-select>
      <!-- <v-select
        :items="baselayers"
        item-text="display_name"
        :return-object="true"
        v-model="currentBasemap"
        no-data-text="Brak warstw"
        height="16"
        attach="#mapSelect"
        placeholder="Warstwy podkładowe"
        id="ribbon-row__select--base"
        class="attach-select"
      ></v-select> -->
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentBasemap: {
      get() {
        return this.$store.getters.getCurrentBasemap;
      },
      set(value) {
        this.$root.$emit("switchBasemapByName", value.display_name);
        this.$store.commit("setCurrentBasemap", value.display_name);
      }
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    baselayers() {
      return this.$store.getters.getBaselayers;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/CommonComp.vue